"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sentry = __importStar(require("@sentry/browser"));
const getSentryEnvironment = () => {
    switch (window.location.hostname) {
        case `${process.env.GS1_PRODUCTION}`:
            return 'production';
        default:
            if ((window.location.hostname.includes('ddev.site') === true)) {
                return 'local';
            }
            else {
                return 'unknown-environment';
            }
    }
};
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        allowUrls: [`${process.env.GS1_PRODUCTION}`],
        denyUrls: [
            // Ignore noisy browser extensions:
            /extensions\//i,
            // Chrome/Chromium specific
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            // Safari specific
            /^safari-extension:\/\//i,
            // Firefox specific
            /^resource:\/\//i,
            'cookiefirst.com',
            'googletagmanager.com'
        ],
        dsn: `${process.env.SENTRY_BROWSER_PROJECT_DSN}`,
        environment: `${(getSentryEnvironment())}`,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Capture (valid) `console` events throughout the codebase /w sentry.
            // Limits messages to warnings, errors, debugs and traces, standard logs are NOT output for spamming reasons from other applications (browser apps, 3rd parties, ...)
            // Therefore: If we need to throw errors from JS do actually throw them (as you would in PHP)
            // See: https://docs.sentry.io/platforms/javascript/usage/#capturing-errors
            // Also console.log() -> console.error().
            // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/captureconsole/
            Sentry.captureConsoleIntegration({ levels: ['warn', 'error', 'debug', 'trace'] }),
            // Capture erroneous calls to the Fetch and XHR APIs.
            // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/
            Sentry.httpClientIntegration(),
            // Since we've, on occasion, inlined JavaScript in template files, we'll also add the ContextLines integration to cover these. ;)
            // see: https://docs.sentry.io/platforms/javascript/configuration/integrations/contextlines/
            Sentry.contextLinesIntegration()
        ],
        release: `${process.env.SENTRY_RELEASE}`,
        // Just in case some env has set TYPO3 Context to Production, make sure browser tracing is only done in production.
        tracePropagationTargets: [`${process.env.GS1_PRODUCTION}`],
        tracesSampleRate: 1.0,
    });
}
